"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _types = require("../../../types");
var _components = require("../../../components");
var _ = require("../..");
var _Screen = require("./Screen");
var _utils2 = require("../utils");
var _VideoChatCubbyContext = require("../VideoChatCubbyContext");
var _excluded = ["children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var canSubmitBillingSection = function canSubmitBillingSection(note) {
  return !!(note.posCode && !(0, _lodash.isEmpty)(note.icdCodes));
};
var Title = function Title(_ref) {
  var title = _ref.title,
    required = _ref.required;
  return /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-body-sm-medium text-grey-55"
  }, title, required && /*#__PURE__*/_react.default.createElement("span", {
    className: "text-alertred-60"
  }, "*"));
};
var Section = function Section(_ref2) {
  var children = _ref2.children,
    titleProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "py-[24px] text-black tw-body-sm-light flex flex-col gap-y-[8px]"
  }, /*#__PURE__*/_react.default.createElement(Title, titleProps), children);
};
var BillingScreen = function BillingScreen() {
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    readonly = _useVideoChatCubby.readonly,
    onSetStatus = _useVideoChatCubby.onSetStatus,
    setNewNote = _useVideoChatCubby.setNewNote,
    newNote = _useVideoChatCubby.newNote,
    updateNote = _useVideoChatCubby.updateNote,
    refreshNote = _useVideoChatCubby.refreshNote;
  var disabled = newNote.billingCodeStatus === _types.SessionNoteStatus.Submitted || readonly;
  var handleIcdCodeChange = function handleIcdCodeChange(value) {
    setNewNote(function (note) {
      return _objectSpread(_objectSpread({}, note), {}, {
        icdCodes: value
      });
    });
  };
  var handleSelectPosCode = function handleSelectPosCode(e) {
    setNewNote(function (note) {
      return _objectSpread(_objectSpread({}, note), {}, {
        posCode: e.target.value
      });
    });
  };
  return /*#__PURE__*/_react.default.createElement(_Screen.Screen, {
    actionLabel: "Submit",
    actionDisabled: !canSubmitBillingSection(newNote),
    onAction: function onAction() {
      onSetStatus(_utils2.VideoChatCubbyScreen.Billing, _utils2.NoteSectionStatus.Complete);
      updateNote(_objectSpread(_objectSpread({}, newNote), {}, {
        billingCodeStatus: _types.SessionNoteStatus.Submitted
      })).then(function () {
        _utils.toast.success({
          title: 'Submitted billing codes'
        });
        refreshNote();
      });
    }
  }, /*#__PURE__*/_react.default.createElement(Section, {
    title: "ICD-10 codes",
    required: true
  }, /*#__PURE__*/_react.default.createElement("p", null, "Select one or more ICD codes from the dropdown. Choose multiple codes if applicable."), /*#__PURE__*/_react.default.createElement(_.IcdCodeSearch, {
    disabled: disabled,
    value: newNote.icdCodes,
    onChange: handleIcdCodeChange
  })), /*#__PURE__*/_react.default.createElement(Section, {
    title: "Place of Service (POS) code",
    required: true
  }, /*#__PURE__*/_react.default.createElement("p", null, "Select the patient's location during the appointment."), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col gap-y-[8px] pl-[4px]"
  }, /*#__PURE__*/_react.default.createElement(_components.Radio.Group, {
    disabled: disabled,
    name: "POS code",
    value: newNote.posCode,
    onChange: handleSelectPosCode
  }, /*#__PURE__*/_react.default.createElement(_components.Radio, {
    value: _utils.PosCode.Home
  }, "POS 10: Home"), /*#__PURE__*/_react.default.createElement(_components.Radio, {
    value: _utils.PosCode.NotHome
  }, "POS 02: Not home")))), /*#__PURE__*/_react.default.createElement(Section, {
    title: "CPT-10 code"
  }, /*#__PURE__*/_react.default.createElement("p", null, "The CPT-10 code will be auto-assigned at the end of this appointment based on your connection time with the patient.")));
};
exports.BillingScreen = BillingScreen;